import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger);

class ScrolllFade {
  constructor() {
    this.el = document.querySelectorAll('[data-animation="fade"]')
    this._init()
  }

  _init() {
    if (this.el.length === 0) { return }
    this.fadeIn()
  }

  fadeIn() {
    this.el.forEach(el => {
      gsap.from(el, .8, {
        opacity: 0,
        // y: 20,
        // scale: .8,
        // ease: 'back',
        scrollTrigger: {
          trigger: el,
          start: 'top 70%',
          // end: 'bottom 60%',
          // scrub: true, //数値も可能(数値の分慣性が入る)
          // markers: true
        }
      })
    })
  }
}

class ScrolllTextSpasing {
  constructor() {
    this.el = document.querySelectorAll('[data-animation="text"]')
    this._init()
  }

  _init() {
    if (this.el.length === 0) { return }
    this.textAnimation()
  }

  textAnimation() {
    this.el.forEach(el => {
      gsap.from(el, 1, {
        opacity: 0,
        letterSpacing: '0.4em',
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 70%',
          // end: 'bottom 60%',
          // scrub: true, //数値も可能(数値の分慣性が入る)
          // markers: true
        }
      })
    })
  }
}

new ScrolllFade()
new ScrolllTextSpasing()

